<template>
  <div class="table-responsive margin-top-1-perc">
    <table class="table table-striped">
      <!-- <thead>
        <tr>
          <th class="text-align-center border-right">
          </th>
          <th v-for="key in columns"
          class="text-align-center border-right" 
          v-if="isReleaseColumn(key)" :colspan="getColspan(key)" >
            {{ key.ColumnAlias | capitalize }}
          </th>
        </tr>
      </thead> -->
      <thead>
        <tr>
          <th class="text-align-center border-right">
          </th>
          <th colspan="16" v-for="(key,index) in columns"
          class="text-align-center border-right" 
          v-if="isChallengeColumn(key)" :key="index">
            {{ key.ColumnAlias | capitalize }}
          </th>
        </tr>
      </thead>
      <thead>
        <tr>
          <th v-for="(key,index) in columns" 
            @click="sortBy(key.ColumnName)"
            :class="{ active: sortKey == key.ColumnName }" class="text-align-center border-right" v-if="(!isChallengeColumn(key))&&(!isReleaseColumn(key))" :key="index">
            {{ key.ColumnAlias | capitalize }}
            <span class="arrow" :class="checkSortable(key.ColumnName) == true ? (sortOrders[key.ColumnName] > 0 ? 'asc' : 'dsc') : 'none'">
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(entry,index) in filteredData" class="" :key="index">
          <td v-for="(key,index) in columns" class="border-right" v-if="(!isChallengeColumn(key))&&(!isReleaseColumn(key))" :key="index">
            <span v-if="isLinkColumn(key.ColumnName)" class="text-decoration-underline text-color-blue cursor-pointer" @click="updateDetails($event,key.ColumnName,entry)">
              <!-- <a href=""> {{entry[key.ColumnName]}}</a>   -->
              {{entry[key.ColumnName]}}
            </span>
            <span v-else>
              {{entry[key.ColumnName]}}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>  
</template>

<script>
export default {
  props: {
    data: Array,
    columns: Array,
    sortColumns: Array,
    filterKey: String,
    linkColumns: Array,
    colspanArr: Array
  },
  data: function () {
    if (this.data === undefined || this.data === null) {
      return
    }
    var sortOrders = {}
    /* this.columns.forEach(function (key) {
      sortOrders[key] = 1
    }) */
    this.sortColumns.forEach(function (key) {
      sortOrders[key] = 1
    })
    return {
      sortKey: '',
      sortOrders: sortOrders
    }
  },
  components: {},
  computed: {
    filteredData: function () {
      var sortKey = this.sortKey
      var filterKey = this.filterKey && this.filterKey.toLowerCase()
      var order = this.sortOrders[sortKey] || 1
      var data = this.data
      if (filterKey) {
        data = data.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
      if (sortKey) {
        data = data.slice().sort(function (a, b) {
          a = a[sortKey]
          b = b[sortKey]
          return (a === b ? 0 : a > b ? 1 : -1) * order
        })
      }
      return data
    }
  },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  },
  methods: {
    sortBy: function (key) {
      console.log('SORT KEY : ' + key)
      console.log('SORT COLUMNS : ' + this.sortColumns.indexOf(key))
      if (this.sortColumns.indexOf(key) > -1) {
        this.sortKey = key
        this.sortOrders[key] = this.sortOrders[key] * -1
      }
    },
    checkSortable: function (key) {
      return this.sortColumns.indexOf(key) > -1
    },
    isLinkColumn: function (key) {
      return this.linkColumns.indexOf(key) > -1
    },
    isChallengeColumn: function (key) {
      // console.log('isChallengeColumn >>>>>>> ' + key.ColumnAlias)
      return /:/i.test(key.ColumnAlias)
    },
    isReleaseColumn: function (key) {
      // console.log('isChallengeColumn >>>>>>> ' + key.ColumnAlias)
      var result = /Release/i.test(key.ColumnAlias)
      return result
    },
    getColspan: function (key) {
      var valueToReturn = 1
      for (var i = 0; i < this.colspanArr.length; i++) {
        if (key.ColumnAlias.toLowerCase() === this.colspanArr[i].ReleaseTS.toLowerCase()) {
          valueToReturn = this.colspanArr[i].ColSpan
          break
        }
      }
      return valueToReturn
    }
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* table {
  border: 2px solid #f39c12;
  border-radius: 3px;
  background-color: #fff;
}

th {
  background-color: #f39c12;
  color: rgba(255,255,255,0.66);
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

td {
  background-color: #f9f9f9;
}

th, td {
  min-width: 120px;
  padding: 10px 20px;
}

th.active {
  color: #fff;
}

th.active .arrow {
  opacity: 1;
} */
.cursor-pointer{
  cursor: pointer;
}
.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #000;
}

.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}

.arrow.none{
  display: none;
}
.text-decoration-underline {
  text-decoration: underline;
}
.text-color-blue {
  color: blue;
}
.text-align-center{
  text-align: center !important;
}
.border-right{
    border-right: 1px solid #aaa !important;
}
.width{
  width: 50% !important;
}
.border-red{
  border: 1px solid red;
}

.vertical-align {
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/SortableGridForChallengeWithReleaseAndChallengeTitle.vue